import React from 'react';
import './App.css';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Navigation from "./components/navigation/Navigation";
import MapPage from './pages/MapPage';
import mySpotListPage from './pages/MySpotListPage';
import SpotDetailPage from './pages/SpotDetailPage';
import News from './pages/NewsPage';
import OverviewPage from './pages/OverviewPage';
import BuoysPage from './pages/BuoysPage';
import Footer from './components/footer/footer';

function App() {

  return (
    <div>
      <BrowserRouter>
        <Navigation originalTitle="Home"/>
        <Switch>
          <Route exact path="/" component={OverviewPage} />
          <Route path="/home" component={OverviewPage} />
          <Route path="/map" component={MapPage} />
          <Route path="/map-buoys/:loadbuoys" component={MapPage} />
          <Route path="/myspots" component={mySpotListPage} />
          <Route path="/spotdetail/:spotId" component={SpotDetailPage} />
          <Route path="/news" component={News} />
          <Route path="/forecast" component={OverviewPage} />
          <Route path="/buoys-forecast" component={BuoysPage} />
        </Switch>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;